import React, { PureComponent } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';

import CoreUtils from '../common/utils/CoreUtils';

import PowerexLogoWhite from '../media/PowerexLogoWhite.png';

export class NavHeader extends PureComponent {
  static displayName = NavHeader.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {
    return (
      <header className="pwx-main-header">
        <Navbar className="navbar-expand-sm navbar-toggleable-sm">
          <Container className="pwx-header-container" fluid>
            <NavbarBrand className="pwx-header-link" tag={Link} to="/">
              <img className="pwx-main-logo" src={PowerexLogoWhite} alt="Powerex" />
            </NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
              <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                <ul className="navbar-nav flex-grow">
                {this.props.navLinks.map((navLink) => {
                  return navLink.visible
                    ? CoreUtils.isDefinedAndNotNull(navLink.logoImage)
                      ? (
                          <NavItem key={navLink.key}>
                            <NavLink className="pwx-header-link" tag={Link} to={navLink.pathName}>
                              <img className="pwx-header-logo" src={navLink.logoImage} alt={navLink.displayName} />
                            </NavLink>
                          </NavItem>
                        )
                      : (
                          <NavItem key={navLink.key}>
                            <NavLink className="pwx-header-link" tag={Link} to={navLink.pathName}>
                              <div className="pwx-header-text">{navLink.displayName}</div>
                            </NavLink>
                          </NavItem>
                        )
                    : (<div key={navLink.key} />)
                  })}
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}